import {myUserAcademy} from "@/lib/services/academyService";


export function Can({permission, children, falsyElement = null, skeleton = true}) {

    if (hasPermission(permission)) {
        return children
    }

    return falsyElement;

}

export function CanWhenHasAny({permissions, children}) {
    let hasAny = false;
    permissions.forEach((permission) => {
        if (hasPermission(permission)) {
            hasAny = true;
        }
    })
    return hasAny ? children : null;

}


function getPermissionLocalStorage() {
    let data = myUserAcademy()
    let myPermission = [];
    if (data?.roles?.length > 0) {
        data?.roles.forEach(role => {
            if (role?.permissions?.length > 0) {
                role.permissions.forEach((permission) => {
                    myPermission.push(permission?.name);
                })
            }
        })
    }
    return myPermission


}

export function hasPermission(permission) {


    const myPermissions = getPermissionLocalStorage()
    const currentAcademy = myUserAcademy();

    if (!myPermissions || !currentAcademy) {
        return false;
    }

    if (!permission) {
        return true;
    }

    if (currentAcademy?.permission === 'admin') {
        return true;
    }

    if (currentAcademy?.user?.permission === 'supervisor') {
        return true;
    }


    return myPermissions.includes(permission);
}


export function hasPermissionLink(permission, link) {
    return hasPermission(permission) ? link : '#'
}